import React, {  useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const CandidateJobProfileWorkQualification = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    // useEffect(()=>{
    //   toast.dismiss();
    //   if(props.userAuth.users_access_token && Object.keys(props.workAndQualificationDetails).length === 0)
    //     dispatch(getDataOnRequest(props.userAuth.users_access_token,'SetWorkAndQualification','SET_WORK_AND_QUALIFICATION_DETAILS'))
          
    // },[props.userAuth.users_access_token])

    useEffect(() => {
  toast.dismiss();

  if (
    props.userAuth.users_access_token &&
    Object.keys(props.workAndQualificationDetails).length === 0
  ) {
    dispatch(
      getDataOnRequest(
        props.userAuth.users_access_token,
        'SetWorkAndQualification',
        'SET_WORK_AND_QUALIFICATION_DETAILS'
      )
    );
  }
}, [
  props.userAuth.users_access_token,
  props.workAndQualificationDetails,
  dispatch
]);


    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    workAndQualificationDetails:state.workAndQualificationDetails.workAndQualificationDetails,
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData
  };
};

const composedCandidateJobProfileWorkQualification = compose(connect(mapStateToProps), CandidateJobProfileWorkQualification)
export default composedCandidateJobProfileWorkQualification;

